import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const NoteIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="31"
			height="30"
			viewBox="0 0 31 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.4"
				d="M9.7125 27.5H21.275C24.6375 27.5 27.3625 24.775 27.3625 21.4125V10.4625C27.3625 7.1 24.6375 4.375 21.275 4.375H9.7125C6.35 4.375 3.625 7.1 3.625 10.4625V21.4C3.625 24.775 6.35 27.5 9.7125 27.5Z"
				fill="white"
			/>
			<path
				d="M10.8625 7.8625C10.3375 7.8625 9.92505 7.4375 9.92505 6.925V3.4375C9.92505 2.925 10.3375 2.5 10.8625 2.5C11.3875 2.5 11.8 2.925 11.8 3.4375V6.9125C11.8 7.4375 11.3875 7.8625 10.8625 7.8625Z"
				fill="white"
			/>
			<path
				d="M20.1375 7.8625C19.6125 7.8625 19.2 7.4375 19.2 6.925V3.4375C19.2 2.9125 19.625 2.5 20.1375 2.5C20.6625 2.5 21.0749 2.925 21.0749 3.4375V6.9125C21.0749 7.4375 20.6625 7.8625 20.1375 7.8625Z"
				fill="white"
			/>
			<path
				d="M18.975 17.1377H9.69995C9.17495 17.1377 8.76245 16.7127 8.76245 16.2002C8.76245 15.6877 9.18745 15.2627 9.69995 15.2627H18.975C19.5 15.2627 19.9125 15.6877 19.9125 16.2002C19.9125 16.7127 19.5 17.1377 18.975 17.1377Z"
				fill="white"
			/>
			<path
				d="M15.5 21.7749H9.69995C9.17495 21.7749 8.76245 21.3499 8.76245 20.8374C8.76245 20.3124 9.18745 19.8999 9.69995 19.8999H15.5C16.025 19.8999 16.4375 20.3249 16.4375 20.8374C16.4375 21.3499 16.025 21.7749 15.5 21.7749Z"
				fill="white"
			/>
		</svg>
	);
};

export default memo(NoteIcon);
